var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11726 9.39367L9.36573 17.2529C9.50336 17.3841 9.68621 17.4573 9.87636 17.4573C10.0665 17.4573 10.2494 17.3841 10.387 17.2529L10.3959 17.244C10.4628 17.1804 10.5161 17.1038 10.5526 17.019C10.589 16.9341 10.6078 16.8427 10.6078 16.7504C10.6078 16.6581 10.589 16.5667 10.5526 16.4818C10.5161 16.397 10.4628 16.3204 10.3959 16.2568L2.62842 8.8564L10.3959 1.45897C10.4628 1.39536 10.5161 1.3188 10.5526 1.23395C10.589 1.14909 10.6078 1.05771 10.6078 0.965361C10.6078 0.873013 10.589 0.781631 10.5526 0.696775C10.5161 0.611917 10.4628 0.535358 10.3959 0.471754L10.387 0.462873C10.2494 0.331673 10.0665 0.25848 9.87636 0.25848C9.68621 0.25848 9.50336 0.331673 9.36573 0.462873L1.11726 8.32209C1.04471 8.3912 0.986963 8.47433 0.947503 8.56643C0.908043 8.65853 0.887695 8.75768 0.887695 8.85788C0.887695 8.95807 0.908043 9.05723 0.947503 9.14933C0.986963 9.24142 1.04471 9.32455 1.11726 9.39367Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationBackArrow);
export default __webpack_public_path__ + "static/media/PaginationBackArrow.6579693b2f49023205ada03647ac3c68.svg";
export { ForwardRef as ReactComponent };